import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.search');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-search',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.search/view.scss */
:host {
  display: block;
  height: 100%;
}

mark {
  background: #fef08a;
  padding: 0 1px;
  border-radius: 2px;
}`],
})
export class PortalLpsysadminCollabSearchComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public q: string = '';
    public results: any[] = [];
    public counts: any = {};
    public workspaces: any[] = [];
    public filterWs: string = '';
    public filterType: string = '';
    public loaded: boolean = false;
    public searching: boolean = false;

    public allTypes = [
        { key: 'task', label: '업무', icon: 'fa-list-check', color: 'text-blue-500' },
        { key: 'post', label: '게시글', icon: 'fa-newspaper', color: 'text-emerald-500' },
        { key: 'chat', label: '채팅', icon: 'fa-comments', color: 'text-sky-500' },
        { key: 'file', label: '파일', icon: 'fa-file', color: 'text-amber-500' },
        { key: 'meeting', label: '회의', icon: 'fa-video', color: 'text-violet-500' },
        { key: 'member', label: '멤버', icon: 'fa-user', color: 'text-rose-500' },
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.loadWorkspaces();
        this.loaded = true;
        await this.service.render();
    }

    public async loadWorkspaces() {
        const r = await wiz.call("search", { q: '__none__' });
        if (r.code === 200) this.workspaces = r.data.workspaces || [];
    }

    public typeMeta(t: string) {
        return this.allTypes.find(x => x.key === t) || { label: t, icon: 'fa-circle', color: 'text-zinc-400' };
    }

    public filteredResults() {
        if (!this.filterType) return this.results;
        return this.results.filter(r => r.type === this.filterType);
    }

    public async onSearch() {
        if (!this.q.trim()) {
            this.results = []; this.counts = {};
            await this.service.render();
            return;
        }
        this.searching = true;
        await this.service.render();
        const params: any = { q: this.q.trim() };
        if (this.filterWs) params.workspace_id = this.filterWs;
        const r = await wiz.call("search", params);
        if (r.code === 200) {
            this.results = r.data.results || [];
            this.counts = r.data.counts || {};
        }
        this.searching = false;
        await this.service.render();
    }

    public open(r: any) {
        if (r.link) this.service.href(r.link);
    }

    public highlight(text: string) {
        if (!text || !this.q) return text;
        const escaped = this.q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return text.replace(new RegExp(`(${escaped})`, 'gi'),
            '<mark class="bg-yellow-200 text-zinc-900">$1</mark>');
    }
}

export default PortalLpsysadminCollabSearchComponent;